module.exports = __webpack_public_path__ + "static/media/md-rose.7476d50e.svg";